import React, { useContext } from 'react';
import { Pencil } from 'lucide-react';
import { AutomationEditorContext } from '../../AutomationEditorContext';
import styles from '../SendMessageStep.module.css';

interface EmailPreviewProps {
  html: string;
}

export const EmailPreview: React.FC<EmailPreviewProps> = ({ html }) => {
  const { editor } = useContext(AutomationEditorContext)!;

  return (
    <figure className={styles.emailPreview}>
      <div className={styles.scrollArea}>
        <iframe srcDoc={html} title="Email Preview" sandbox="allow-same-origin" />
      </div>
      <button type="button" onClick={editor.openStripo}>
        <Pencil />
        <span>Edit</span>
      </button>
    </figure>
  );
};
